export const ADD_PRODUCT = "product/add";
export const ADD_PRODUCT_QUANTITY = "product/addQuantity";
export const REMOVE_PRODUCT_QUANTITY = "product/removeQuantity";
export const ADD_MANY_QUANTITY = "product/addManyQuantity";

